import { Box, Button, Drawer, List, ListItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import logoImg from "../../../images/logo-przezmorze.svg";
import type { UserContext } from "../auth/auth";
import { useSiteMap } from "./Sitemap";

interface Props {
  readonly context: UserContext | null;
  readonly open: boolean;
  readonly onClose: () => void;
}

export function TopmostMobileMenu({ open, onClose, context }: Props) {
  const sitemap = useSiteMap(context);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": { boxSizing: "border-box", width: 260 },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <Box
          component="img"
          src={logoImg}
          alt="Przezmorze.pl"
          sx={{ height: "auto", width: "auto", maxHeight: "28px", maxWidth: "160px", objectFit: "contain" }}
        />
      </Box>
      <List onClick={onClose} sx={{ pt: 1 }}>
        {sitemap.map(({ label, icon, link }) => {
          const active = location.pathname === link;
          return (
            <ListItem disablePadding key={label}>
              <Button
                fullWidth
                color="inherit"
                startIcon={icon}
                sx={{
                  borderRadius: 0,
                  py: 1.5,
                  px: 2,
                  textTransform: "none",
                  justifyContent: "flex-start",
                  color: active ? "primary.main" : "text.primary",
                  bgcolor: active ? "rgba(13,110,253,0.08)" : "transparent",
                }}
                onClick={() => navigate(link)}
              >
                {label}
              </Button>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
